import { render, staticRenderFns } from "./CarrierAreaInfoCard.vue?vue&type=template&id=5aa16be6&scoped=true&"
import script from "./CarrierAreaInfoCard.vue?vue&type=script&lang=js&"
export * from "./CarrierAreaInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa16be6",
  null
  
)

export default component.exports